import React from "react";
import styles from "./SocietyHomepageContact.module.css";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Grid2} from "@mui/material";
import {useSectionsRefs} from "../../mainWrapper/MainWrapper";
import SocietyHomepageContactMap from "./societyHomepageContactMap/SocietyHomepageContactMap";
import OpeningHours from "./openingHours/OpeningHours";
import ContactDetails from "./contactDetails/ContactDetails";
import SocietyHomepageContactForm from "./societyHomepageContactForm/SocietyHomepageContactForm";

const SocietyHomepageContact = () => {

    const {contactSection} = useSectionsRefs();

    return (
        <Box
            className={styles.outerBox}
            ref={contactSection}
            sx={{
                backgroundColor: "tertiary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div className={styles.content}>
                <Typography
                    sx={{
                        color: '#ffffff',
                        fontSize: {xs: 30, sm: 40},
                    }}
                    variant={"firstVariant"}
                >
                    CONTACT
                </Typography>

                <Grid2 container size={12} mt={2} mb={6} spacing={6}>
                    <Grid2 display={{xs: 'none', md: 'flex'}} size={7} container height={"550px"}>
                        <SocietyHomepageContactMap/>
                    </Grid2>
                    <Grid2 container size={{xs: 12, md: 5}} direction={"column"} spacing={4}>
                        <ContactDetails/>
                        <OpeningHours/>
                    </Grid2>
                    <Grid2 display={{xs: 'flex', md: 'none'}} size={12} container height={"400px"}>
                        <SocietyHomepageContactMap/>
                    </Grid2>
                </Grid2>

                <SocietyHomepageContactForm/>

            </div>
        </Box>
    );
}

export default SocietyHomepageContact